// Simple centered notice after purchases, redeem, or inventory grants.

import React from "react";

export default function NoticePrompt({
    title = "Done",
    message = "",
    confirmLabel = "OK",
    onConfirm,
}) {
    return (
        <div
            className="guideHeartDemoOverlay noticePrompt"
            role="dialog"
            aria-modal="true"
            aria-labelledby="noticePromptTitle"
        >
            <div className="guideHeartDemoOverlay__panel">
                <div
                    id="noticePromptTitle"
                    className="guideHeartDemoOverlay__title"
                >
                    {title}
                </div>
                {message ? (
                    <p className="guideHeartDemoOverlay__message">{message}</p>
                ) : null}
                <div className="noticePrompt__actions">
                    <button
                        type="button"
                        className="homePrimaryButton guideHeartDemoOverlay__button"
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
